export const BASE = 24